<!-- Events -->
<!-- itemCreated -->

<template>
  <base-sq-card
    style="width: 500px"
  >
    <template v-slot:heading>
      <span class="tile-card-heading">Plans</span>
      <v-spacer></v-spacer>
      <base-btn-menu
        v-if="isStaff"
        icon="mdi-dots-vertical"
      >
        <v-list>
          <v-list-item
            link
          >
            <v-list-item-title>
              <v-icon
                color="blue darken-1"
                class="mr-1"
              >
                mdi-refresh
              </v-icon>

              Refresh
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="dlgAssignPlan = true"
          >
            <v-list-item-title>
              <v-icon
                color="green darken-1"
                class="mr-1"
              >
                mdi-plus
              </v-icon>

              Add Plan
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="dlgPostCharges = true"
          >
            <v-list-item-title>
              <v-icon
                color="teal darken-1"
                class="mr-1"
              >
                mdi-currency-usd
              </v-icon>
              Post Charges
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </base-btn-menu>
    </template>
    <v-data-table
      :headers="calculatedHeaders"
      :items="items"
      :items-per-page="5"
      item-key="tkt_id"
      height="350px"
    >
      <template v-slot:item.__actions="{ item }">
        <v-btn
          color="success"
          @click="editPlan(item)"
        >
          Edit
        </v-btn>
      </template>
      <template v-slot:item.cr_frequency="{ item }">
        <template
          v-if="item.cr_frequency === 1"
        >
          Monthly
        </template>
        <template
          v-if="item.cr_frequency === 6"
        >
          Semi-annual
        </template>
        <template
          v-if="item.cr_frequency === 12"
        >
          Annual
        </template>
      </template>
      <template v-slot:item.nextbill="{ item }">
        <template
          v-if="item.nextbill"
        >
          {{ formatDate(item.nextbill, 'MM/DD/YYYY', true) }}
        </template>
      </template>
      <template v-slot:item.cr_contract_end="{ item }">
        <template
          v-if="item.cr_contract_end"
        >
          {{ formatDate(item.cr_contract_end) }}
        </template>
      </template>
    </v-data-table>
    <!--           Edit Plan Modal-->
    <v-dialog
      v-model="dlgEditPlan"
      class="rounded-0"
      max-width="600px"
      persistent
    >
      <base-sq-card
        :dialog="true"
      >
        <template v-slot:heading>
          <span class="tile-card-heading">Edit Plan</span>
        </template>
        <acct-edit-plan
          :item="selectedRate"
          @closeForm="dlgEditPlan = false"
        ></acct-edit-plan>
      </base-sq-card>
    </v-dialog>
    <!--           Assign Plans Modal-->
    <v-dialog
      v-model="dlgAssignPlan"
      class="rounded-0"
      max-width="600px"
      persistent
    >
      <base-sq-card
        :dialog="true"
      >
        <template v-slot:heading>
          <span class="tile-card-heading">Assign Plan</span>
        </template>
        <acct-add-plan
          @closeForm="dlgAssignPlan = false"
        ></acct-add-plan>
      </base-sq-card>
    </v-dialog>
    <!--           Post Charges Modal-->
    <v-dialog
      v-model="dlgPostCharges"
      max-width="600px"
      persistent
    >
      <acct-post-charges
        @closeForm="dlgPostCharges = false"
      ></acct-post-charges>
    </v-dialog>
  </base-sq-card>
</template>

<script>
  // Utilities
  import { mapActions, mapGetters } from 'vuex'
  import {
    ACCT_GET_ACCOUNT_RATES, PLAN_GET_PLANS,
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  export default {
    name: 'PowAccountRates',
    components: {
      AcctEditPlan: () => import('@/components/acct/EditPlan'),
      AcctAddPlan: () => import('@/components/acct/AddPlan'),
      AcctPostCharges: () => import('@/components/acct/PostCharges'),
    },
    mixins: [basicMixin],

    inheritAttrs: false,

    props: {
      item: {
        type: Object,
        default: () => ({
          name: undefined,
          invoice: undefined,
          due_date: undefined,
          total: undefined,
          paid: undefined,
          is_paid: undefined,
          details: undefined,
        }),
      },
    },
    data: function () {
      return {
        selectedRate: {
          crid: null,
        },
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        dlgEditPlan: false,
        dlgAssignPlan: false,
        dlgPostCharges: false,
        headers: [
          {
            text: 'Action',
            align: 'start',
            sortable: false,
            value: '__actions',
            staff: true,
          },
          {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'rg_name',
          },
          { text: 'Price', value: 'price' },
          { text: 'Freq', value: 'cr_frequency' },
          { text: 'Next Bill', value: 'nextbill' },
          { text: 'Contract End', value: 'cr_contract_end' },
        ],
      }
    },

    computed: {
      ...mapGetters({
        items: 'acctSelectedAccountRates',
        selectedAccount: 'acctSelectedAccount',
        isStaff: 'authIsStaff',
      }),
      calculatedHeaders: function () {
        const calcd = this.headers.filter((col) => {
          if (!this.isStaff && col.staff) {
            return false
          }
          return true
        })
        return calcd
      },
    },
    async created () {
      // this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions({
        getRates: ACCT_GET_ACCOUNT_RATES,
      }),
      ...mapActions('planModule', {
        getPlans: PLAN_GET_PLANS,
      }),
      init () {
        console.log(`Initializing ${name} setting values!`, this.item)
        this.getPlans()
        this.getRates({ rowkey: this.selectedAccount.rowkey })
        this.formMode = 'read'
        // console.log(val)
        // this.currentObject = { ...this.item }
        // this.snapshotObject = { ...this.item }
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
      editPlan (plan) {
        this.dlgEditPlan = true
        this.selectedRate = { ...plan }
      },
    },

  }
</script>

<style>
</style>
